/**
 * Format countdown timer as MM:SS
 */
export const formatCountdown = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Format elapsed time as HH:MM:SS
 */
export const formatElapsedTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Format currency value
 */
export const formatCurrency = (value, decimals = 2) => {
  return (value || 0).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};

/**
 * Format crypto price - handles very small prices like SHIB
 * Shows appropriate decimal places based on price magnitude
 */
export const formatPrice = (price) => {
  if (!price || price === 0) return '$0';
  
  // For very small prices (like SHIB), show more decimals
  if (price < 0.0001) {
    return `$${price.toFixed(8)}`;
  } else if (price < 0.01) {
    return `$${price.toFixed(6)}`;
  } else if (price < 1) {
    return `$${price.toFixed(4)}`;
  } else if (price < 100) {
    return `$${price.toFixed(2)}`;
  } else {
    return `$${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
};

/**
 * Format profit/loss with sign
 */
export const formatProfitLoss = (value, decimals = 2) => {
  const formatted = formatCurrency(Math.abs(value), decimals);
  return value >= 0 ? `+$${formatted}` : `-$${formatted}`;
};

/**
 * Get color class based on profit/loss
 */
export const getProfitColor = (value) => {
  return value >= 0 ? 'text-[#00FF41]' : 'text-red-500';
};
